// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__mSBhX","title":"FrontImage_title__3n61K"};